export { PaginationConfig } from '../pagination';



// WEBPACK FOOTER //
// ./components/table/interface.tsx